export default __webpack_public_path__ + "static/media/fMaltoBuza25.8fc6dee9.png";